export enum DefaultErrors {
  UpdateClientBilling = "Failure_Update_ClientBilling",
}

export enum SubscriptionErrors {
  SubscriptionFailure = "subscription.internalError",
}

export enum SystemAdminErrors {
  ErrorAddingAdminNote = "ErrorAddingAdminNote",
}
